module.exports = __webpack_public_path__ + "18c874246385aefe42f60ae29855183e.MP3";